import { Loader as UiLoader } from "ui";

// type Props = ComponentProps["GridSuggestionMenu"]["Loader"];
export function Loader() {
  return <UiLoader />;
}
